import { useAuth } from 'auth/auth-provider/AuthProvider';
import { LoadingPage } from 'components/molecules/loading-page/LoadingPage';
import { useEffect } from 'react';

/**
 * Initiates the login flow using the full redirectUriPath (IMS redirect) directly
 */
export const ImsLoginInitiator = () => {
  const auth = useAuth();

  useEffect(() => {
    auth.login();
  }, [auth.login]);

  return <LoadingPage />;
};
